const initialState = () => ({
  currentReceptionId: null,
});

const state: any = initialState();

const mutations = {
  reset(state: any) {
    const newState: any = initialState();
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key];
    });
  },
  setCurrentReceptionId(state: any, payload: string) {
    state.currentReceptionId = payload;
  },
};

const getters = {
  getCurrentReceptionId: (state: any) => state.currentReceptionId,
};

const actions = {
  reset({ commit }: any) {
    commit("reset");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
